import React from 'react';
import PropTypes from 'prop-types';
import ClinicCard from './ClinicCard';

const ClinicsList = ({ 
    clinics, 
    loading, 
    error, 
    selectedLocation, 
    title = "Clinics",
    onClinicAction,
    actionButtonText = "View Details",
    showActionButton = true,
    gridCols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
    isFromManagement = false
}) => {
    if (loading) {
        return (
            <div className="flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md mb-6">
                {error}
            </div>
        );
    }

    if (!selectedLocation.cityId) {
        return (
            <div className="bg-gray-50 rounded-lg p-8 text-center">
                <p className="text-gray-600">Please select a location to view clinics.</p>
            </div>
        );
    }

    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">
                    {title}
                </h2>
                <span className="text-sm sm:text-base text-gray-600">
                    {clinics.length} {clinics.length === 1 ? 'clinic' : 'clinics'} found
                </span>
            </div>

            {clinics.length === 0 ? (
                <div className="bg-gray-50 rounded-lg p-6 sm:p-8 text-center">
                    <p className="text-gray-600">No clinics found in this area.</p>
                </div>
            ) : (
                <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6`}>
                    {clinics.map((clinic) => (
                        <ClinicCard
                            key={clinic.clinicId}
                            clinic={clinic}
                            onManage={showActionButton ? onClinicAction : undefined}
                            showOnboardButton={false}
                            isFromManagement={isFromManagement}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

ClinicsList.propTypes = {
    clinics: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
    selectedLocation: PropTypes.object.isRequired,
    title: PropTypes.string,
    onClinicAction: PropTypes.func,
    actionButtonText: PropTypes.string,
    showActionButton: PropTypes.bool,
    gridCols: PropTypes.string,
    isFromManagement: PropTypes.bool
};

ClinicsList.defaultProps = {
    loading: false,
    error: null,
    showActionButton: true,
    gridCols: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    isFromManagement: false
};

export default ClinicsList; 